module.exports = __webpack_public_path__ + "assets/img/top5.096fa33b.webp";